/*
 * Imports
 */

// const _ = require('lodash')
const moment = require('moment')

/*
 * General Helper functions
 */

const responseHandler = (response) => {
  // Finer grained response handling
  // TO DO - Alter api/fetch.js to return the full response so we can check status codes
  // TO DO - Update all Vuex interactions with API's (which utilize fetch.js) to return response.body instead of response

  // Presume if we haven't returned an object that looks like { success: true, message: 'fooMessage' }, that it's an error
  if (!response.success) {
    return { success: false, error: errorHandler(response) }
  }

  return response
}

const errorHandler = (response) => {
  /* Client-side errors - wrap in a 'body'
    { code: 'INVALID_API_CALL', message: 'Incorrect parameters' }
  */
  if (!_.get(response, 'body', false)) {
    response = { body: response }
  }

  // Two types of errors from Sails

  /* For 500's
  {
    "cause": "Exception: `sharePerson` failed (\"forbidden\").  The user does not have privileges to share the object\n    at Object.fn (/app/api/controllers/share/share-person.js:68:62)\n    at wrapper (/app/node_modules/@sailshq/lodash/lib/index.js:3275:19)\n    at Deferred._handleExec (/app/node_modules/machine/lib/private/help-build-machine.js:1016:29)\n    at Deferred.exec (/app/node_modules/parley/lib/private/Deferred.js:286:10)\n    at Deferred.switch (/app/node_modules/machine/lib/private/help-build-machine.js:1469:16)\n    at Object._requestHandler [as share/share-person] (/app/node_modules/machine-as-action/lib/machine-as-action.js:1152:27)\n    at /app/node_modules/sails/lib/router/bind.js:248:46\n    at routeTargetFnWrapper (/app/node_modules/sails/lib/router/bind.js:395:9)\n    at Layer.handle [as handle_request] (/app/node_modules/express/lib/router/layer.js:95:5)\n    at next (/app/node_modules/express/lib/router/route.js:137:13)\n    at Route.dispatch (/app/node_modules/express/lib/router/route.js:112:3)\n    at Layer.handle [as handle_request] (/app/node_modules/express/lib/router/layer.js:95:5)\n    at /app/node_modules/express/lib/router/index.js:281:22\n    at Function.process_params (/app/node_modules/express/lib/router/index.js:335:12)\n    at next (/app/node_modules/express/lib/router/index.js:275:10)\n    at next (/app/node_modules/express/lib/router/route.js:127:14)\n    at alwaysAllow (/app/node_modules/sails/lib/hooks/policies/index.js:178:16)\n    at routeTargetFnWrapper (/app/node_modules/sails/lib/router/bind.js:395:9)\n    at Layer.handle [as handle_request] (/app/node_modules/express/lib/router/layer.js:95:5)\n    at next (/app/node_modules/express/lib/router/route.js:137:13)\n    at Route.dispatch (/app/node_modules/express/lib/router/route.js:112:3)\n    at Layer.handle [as handle_request] (/app/node_modules/express/lib/router/layer.js:95:5)",
    "isOperational": true,
    "code": "forbidden",
    "exit": "forbidden",
    "traceRef": {}
  }
*/

  /* For 400 bad requests
  {
    "code": "E_MISSING_OR_INVALID_PARAMS",
    "problems": [
      "\"groupId\" is required, but it was not defined."
    ],
    "message": "The server could not fulfill this request (`POST /v1/share/person`) due to 1 missing or invalid parameter.  **The following additional tip will not be shown in production**:  Tip: Check your client-side code to make sure that the request data it sends matches the expectations of the corresponding parameters in your server-side route/action.  Also check that your client-side code sends data for every required parameter.  Finally, for programmatically-parseable details about each validation error, `.problems`. "
  }
*/
  let error

  if (_.isObject(response)) {
    error = {
      code: _.get(response, 'body.code', 'Error Code Not Found'),
      message: _.get(response, 'body.message', 'Message Not Found'),
      problems: _.get(response, 'body.problems', [])
    }
  }

  if (_.isString(response)) {
    error = {
      code: response.status,
      message: response,
      problems: []
    }
  }

  return error
}

const errorToHtml = (error) => {
  if (_.isString(error)) {
    return '<p>' + error + '</p>'
  }

  if (_.isObject(error)) {
    let lines = []

    lines.push('Code: ' + error.code)
    lines.push('Message: ' + error.message)

    const problems = _.get(error, 'problems', false)
    if (problems) {
      problems.map(p => {
        lines.push(p)
      })
    }

    const fields = _.get(error, 'attrNames', false)
    if (fields) {
      lines.push('Please check the values of following field(s):')
      fields.map(p => {
        lines.push(p)
      })
    }

    return '<p>' + lines.join('</p><p>') + '</p>'
  }
}

/*
 * Authorized user helper functions
 */

const getCurrentUserId = (context) => {
  const user = context._vm.$auth.user()
  return user.id
}

/*
 * Date Helpers
 */

const unixToHuman = (value) => {
  if (!value) {
    return ''
  }

  return moment.unix(value).format('MM/DD/YYYY hh:mm')
}

const unixToHumanMS = (value) => {
  if (!value) {
    return ''
  }
  let newValue = Math.floor(value / 1000)
  return moment.unix(newValue).format('MM/DD/YYYY hh:mm')
}

const formatDate = (value) => {
  if (value === '0000-00-00 00:00:00') {
    return ''
  }

  return moment(value).format('MM/DD/YYYY hh:mm a')
}

const defaultDate = () => {
  return moment(new Date()).format('MM/DD/YYYY')
}

const validateYear = (year) => {
  var text = /^[0-9]+$/
  if (year.length === 4) {
    if (year !== 0) {
      if ((year !== '') && (!text.test(year))) {
        return false
      }
      if (year.length !== 4) {
        return false
      }
      var currentyear = new Date().getFullYear()
      if ((year < 1920) || (year > currentyear)) {
        return false
      }
      return true
    }
  }
}

/*
 * Environment checks
 *  - Potential environments - [ 'development', 'production' ]
 */
const getEnv = () => {
  return process.env.NODE_ENV
}

const isEnv = (envName) => {
  if (getEnv() === envName) {
    return true
  }
  return false
}

export default {
  getCurrentUserId,
  responseHandler,
  errorToHtml,
  getEnv,
  isEnv,
  defaultDate,
  validateYear,
  unixToHuman,
  unixToHumanMS,
  formatDate
}



// WEBPACK FOOTER //
// ./src/utils.js